module.exports = __webpack_public_path__ + "img/yakiton_ekoda.9320516c.jpg";